import { render, staticRenderFns } from "./ws-theme-modal.vue?vue&type=template&id=2bf0175b&scoped=true&"
import script from "./ws-theme-modal.vue?vue&type=script&lang=js&"
export * from "./ws-theme-modal.vue?vue&type=script&lang=js&"
import style0 from "./ws-theme-modal.vue?vue&type=style&index=0&id=2bf0175b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf0175b",
  null
  
)

export default component.exports